import classNames from 'classnames'
import { useCallback } from 'react'

const CLASS_PREFIX = 'rs'

export const useClassNames = (name: string) => {
  const componentName = `${CLASS_PREFIX}-${name}`

  const prefix = useCallback(
    (...classes: classNames.ArgumentArray) =>
      classNames(...classes)
        .split(' ')
        .filter(Boolean)
        .map(className => `${componentName}-${className}`)
        .join(' '),
    [componentName],
  )

  const withClassPrefix = useCallback(
    (...classes: classNames.ArgumentArray) => {
      const prefixedClasses = prefix(classes)
      return prefixedClasses ? `${componentName} ${prefixedClasses}` : componentName
    },
    [componentName, prefix],
  )

  return { withClassPrefix, prefix, merge: classNames }
}
